import { leafTasksUnder, rollupPct, weekSpan } from "./util";

// Two-week axis buckets; an odd final week gets a bucket of its own.
function buckets(weeks) {
  const out = [];
  for (let w = 1; w <= weeks; w += 2) out.push(w + 1 <= weeks ? `W${w}-${w + 1}` : `W${w}`);
  return out;
}

export default function WorkplanTimeline({ tree, nodes, weeks = 12 }) {
  const BUCKETS = buckets(weeks);
  return (
    <div className="wp-timeline" data-testid="wp-timeline">
      <div
        className="wp-tl-axis"
        style={{ gridTemplateColumns: `150px ${BUCKETS.map((b) => (b.includes("-") ? "2fr" : "1fr")).join(" ")}` }}
      >
        <span />
        {BUCKETS.map((b) => (
          <span key={b}>{b}</span>
        ))}
      </div>
      {tree.map((theme) => {
        const span = weekSpan(nodes, theme.id);
        const tasks = leafTasksUnder(nodes, theme.id);
        const pct = rollupPct(tasks);
        const isCrit = tasks.some((t) => t.critical);
        const left = span ? ((span.start - 1) / weeks) * 100 : 0;
        const width = span ? ((span.end - span.start + 1) / weeks) * 100 : 0;
        return (
          <div className="wp-tl-row" key={theme.id} data-testid={`wp-tl-${theme.id}`}>
            <div className="wp-tl-name">{theme.title}</div>
            <div className="wp-tl-track">
              {span && (
                <div
                  className={`wp-tl-seg ${isCrit ? "crit" : ""}`}
                  style={{ left: `${left}%`, width: `${width}%` }}
                  title={`${theme.title} · ${pct}% done`}
                >
                  {pct}%
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
